import { render, staticRenderFns } from "./TabScroller.vue?vue&type=template&id=0dda0ca7&scoped=true&"
import script from "./TabScroller.vue?vue&type=script&lang=js&"
export * from "./TabScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda0ca7",
  null
  
)

export default component.exports